import React from 'react';
import PropTypes from 'prop-types';

import i18n from '../../i18n';
import Utils from '../../utils/utils';

function NextArrow(props) {
    const { className, style, onClick, isCollection } = props;
    return (
        <button
            type="button"
            className={`${isCollection ? 'next-arrow' : `${className} icon-angle-right-rounded`}`}
            style={style}
            onClick={onClick}
        >
            {isCollection ? (
                <>
                    <div className="background-img" />
                    <img src={`${Utils.getAssetsDomain()}/images/website/collection/next.svg`} />
                </>
            ) : (
                i18n.t('common:next')
            )}
        </button>
    );
}

NextArrow.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.object,
    isCollection: PropTypes.bool
};

export default NextArrow;
